<template>
  <div class="create-org">
    <el-dialog
      title="创建企业"
      :visible.sync="visible"
      width="600px"
      top="26vh"
      :close-on-click-modal="false"
      :before-close="
        done => {
          close()
        }
      "
    >
      <div class="create-org-body">
        <div class="create-org-warn">请填写您需要为哪家企业{{ this.isResale ? '申领' : '购买' }}专属印章，并确保企业名称真实有效</div>
        <el-form class="create-org-form" :model="orgForm" :rules="rules" ref="orgForm">
          <el-form-item class="create-org-form-item" v-if="showProvince" prop="province">
            <el-select v-model.trim="orgForm.province" placeholder="请选择您的投标目标所在省份" style="width: 100%">
              <el-option v-for="item in provinceList" :key="item.addressCode" :label="item.address" :value="item.address"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="create-org-form-item" prop="name">
            <el-input v-model.trim="orgForm.name" placeholder="请输入购买企业名称" maxlength="50" @change="changeOrgName"></el-input>
          </el-form-item>
          <el-form-item class="create-org-form-item" prop="orgType">
            <el-select v-model.trim="orgForm.orgType" placeholder="请选择企业类型" style="width: 100%">
              <el-option v-for="item in orgTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="create-org-form-item" prop="codec">
            <el-input v-model.trim="orgForm.codec" placeholder="请输入社会统一信用代码" @change="changeOrgCode"></el-input>
          </el-form-item>
          <template v-if="isHuangShiProject">
            <div>办理证明材料下载： <span style="color:blue;cursor: pointer;" @click="downloadFile">点击立即下载</span></div>
            <el-form-item class="create-org-form-item" prop="credentialSignatureApplicationForm">
              <span>数字证书企业受理表</span>
              <UploadFiles
                :fileList="orgForm.credentialSignatureApplicationForm"
                @getNewFileList="getNewFileList"
                :fileType="1"
              ></UploadFiles>
            </el-form-item>
            <el-form-item class="create-org-form-item" prop="credentialServiceAgreement">
              <span>数字证书服务协议</span>
              <UploadFiles :fileList="orgForm.credentialServiceAgreement" @getNewFileList="getNewFileList" :fileType="2"></UploadFiles>
            </el-form-item>
            <el-form-item class="create-org-form-item" prop="orgBusinessLicense">
              <span>企业三证合一营业执照</span>
              <UploadFiles :fileList="orgForm.orgBusinessLicense" @getNewFileList="getNewFileList" :fileType="3"></UploadFiles>
            </el-form-item>
            <el-form-item class="create-org-form-item" prop="legalPersonAuthorizationAndIdcard">
              <span>法定代表人（或负责人）授权书</span>
              <UploadFiles
                :fileList="orgForm.legalPersonAuthorizationAndIdcard"
                @getNewFileList="getNewFileList"
                :fileType="4"
              ></UploadFiles>
            </el-form-item>
            <!-- <el-form-item class="create-org-form-item" prop="signetCollectTable">
              <span>签章采集表</span>
              <UploadFiles :fileList="orgForm.signetCollectTable" @getNewFileList="getNewFileList" :fileType="5"></UploadFiles>
            </el-form-item>
            <el-form-item class="create-org-form-item" prop="operatorIdcard">
              <span>经办人身份证</span>
              <UploadFiles :fileList="orgForm.operatorIdcard" @getNewFileList="getNewFileList" :fileType="6"></UploadFiles>
            </el-form-item> -->
          </template>
          <div v-if="isApply" style="color:#e63740;font-size: 12px">
            企业已存在，可联系管理员（{{ name }}）邀请您加入，或<span
              @click="handleLink"
              style="color:#0975e1; margin-left: 3px;cursor: pointer;"
              >点击申请加入该企业</span
            >（需管理员同意）
          </div>
          <div v-if="isKefu" style="color:#e63740;font-size: 12px">
            企业已创建，但您的企业不存在管理员，请联系e签宝在线客服，给您的企业设置管理员后再办理
          </div>
        </el-form>
      </div>
      <div slot="footer" class="auth-dialog-footer">
        <el-button class="back-btn" @click="close">取 消</el-button>
        <el-button class="submit btn-primary" type="primary" @click="submit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import { openYsf } from '@/lib/qiyuSDK.js'
import realnameMixin from '@/mixins/realname'
import UploadFiles from './UploadFiles.vue'
// 社会统一信用代码+工商注册号
const TongyiCodecPattern = /(^(91|92)(?:(?![IOZSViozsv])[\dA-Za-z]){16}$)|(^\d{15}$)|(^\d{13}$)/
// 其他：非91/92开头18位 或其他
const OtherCodePattern = /(^(?!91|92)([\dA-Za-z]{18})$)|(^[\dA-Za-z]{1,17}$)|(^[\dA-Za-z]{19,20}$)/

// 白名单校验
const whiteList = {
  '513301005018919996': '杭州市人力资源和社会保障学会',
  '51330000501875868J': '浙江省游泳协会',
  '52331000MJ9799815K': '台州市精筑建设工程施工图审查中心',
  '12330000470017034Y': '浙江省政协委员活动中心',
  '123301024702722463': '杭州市上城区小营市容环境卫生管理所',
  '523301050709567028': '杭州市拱墅区奥航幸福养老服务中心',
}
const ProvinceList = [
  { addressCode: '110000', address: '北京' },
  { addressCode: '120000', address: '天津' },
  { addressCode: '130000', address: '河北省' },
  { addressCode: '140000', address: '山西省' },
  { addressCode: '150000', address: '内蒙古自治区' },
  { addressCode: '210000', address: '辽宁省' },
  { addressCode: '220000', address: '吉林省' },
  { addressCode: '230000', address: '黑龙江省' },
  { addressCode: '310000', address: '上海' },
  { addressCode: '320000', address: '江苏省' },
  { addressCode: '330000', address: '浙江省' },
  { addressCode: '340000', address: '安徽省' },
  { addressCode: '350000', address: '福建省' },
  { addressCode: '360000', address: '江西省' },
  { addressCode: '370000', address: '山东省' },
  { addressCode: '410000', address: '河南省' },
  { addressCode: '420000', address: '湖北省' },
  { addressCode: '430000', address: '湖南省' },
  { addressCode: '440000', address: '广东省' },
  { addressCode: '450000', address: '广西壮族自治区' },
  { addressCode: '460000', address: '海南省' },
  { addressCode: '500000', address: '重庆' },
  { addressCode: '510000', address: '四川省' },
  { addressCode: '520000', address: '贵州省' },
  { addressCode: '530000', address: '云南省' },
  { addressCode: '540000', address: '西藏自治区' },
  { addressCode: '610000', address: '陕西省' },
  { addressCode: '620000', address: '甘肃省' },
  { addressCode: '630000', address: '青海省' },
  { addressCode: '640000', address: '宁夏回族自治区' },
  { addressCode: '650000', address: '新疆维吾尔自治区' },
  { addressCode: '710000', address: '台湾' },
  { addressCode: '810000', address: '香港特别行政区' },
  { addressCode: '820000', address: '澳门特别行政区' },
]

export default {
  name: 'createOrg',
  components: { UploadFiles },
  mixins: [realnameMixin],
  props: {
    visible: Boolean,
    source: Object,
    orgName: String,
    orgCode: String,
    // 是否为转售
    isResale: {
      default: false,
      require: false,
      type: Boolean,
    },
  },
  data() {
    const TongyiCodecCheck = (rule, value, callback) => {
      // 碰到紧急情况放开此校验，后续发布日跟进
      if (this.$route.query.codePass && value.length <= 18) {
        return callback()
      }

      if (TongyiCodecPattern.test(value) || OtherCodePattern.test(value)) {
        return callback()
      }

      return callback(new Error('社会统一信用代码格式错误'))
    }

    return {
      loading: false,
      isApply: false,
      isKefu: false,
      name: '',
      orgForm: {
        name: '',
        codec: '',
        province: '',
        credentialSignatureApplicationForm: [], // 文件类型(1：数字证书及电子签章申请表)
        credentialServiceAgreement: [], // 文件类型(2：数字证书服务协议)
        orgBusinessLicense: [], // 文件类型(3：企业三证合一营业执照副本复印件)
        legalPersonAuthorizationAndIdcard: [], // 文件类型(4：法人（或负责人）授权书、身份证复印件
        // signetCollectTable: [], // 文件类型(5：印章采集表)
        // operatorIdcard: [], // 文件类型(6：经办人身份证)
        orgType: 1,
      },
      msg: null,
      orgId: '', // 接口返回企业的orgId
      rules: {
        name: [{ required: true, message: '请输入购买企业名称', trigger: 'blur' }],
        province: [{ required: true, message: '请选择您的投标目标所在省份', trigger: 'blur' }],
        codec: [
          { required: true, message: '请输入社会统一信用代码', trigger: 'blur' },
          { validator: TongyiCodecCheck, trigger: 'blur' },
        ],
        credentialSignatureApplicationForm: [{ required: true, message: '请上传数字证书企业受理表', trigger: ['blur', 'change'] }],
        credentialServiceAgreement: [{ required: true, message: '请上传数字证书服务协议', trigger: ['blur', 'change'] }],
        orgBusinessLicense: [{ required: true, message: '请上传企业三证合一营业执照', trigger: ['blur', 'change'] }],
        legalPersonAuthorizationAndIdcard: [{ required: true, message: '请上传法定代表人（或负责人）授权书', trigger: ['blur', 'change'] }],
        // signetCollectTable: [{ required: true, message: '请上传印章采集表', trigger: ['blur', 'change'] }],
        // operatorIdcard: [{ required: true, message: '请上传经办人身份证', trigger: ['blur', 'change'] }],
      },
      showProvince: false,
      provinceList: ProvinceList,
      isHuangShiProject: false,
      typeKeyObj: {
        1: 'credentialSignatureApplicationForm',
        2: 'credentialServiceAgreement',
        3: 'orgBusinessLicense',
        4: 'legalPersonAuthorizationAndIdcard',
        // 5: 'signetCollectTable',
        // 6: 'operatorIdcard',
      },
      isQueryAppointFiles: false,
      bizId: '', // 黄石项目需要 业务方bizid
      orgTypeList: [
        {
          label: '企业',
          value: 1,
        },
        {
          label: '个体工商户',
          value: 2,
        },
        {
          label: '党政机关事业单位',
          value: 3,
        },
        {
          label: '其他',
          value: 4,
        },
      ], // 企业类型
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  created() {
    this.orgForm.name = this.orgName || ''
    this.orgForm.codec = this.orgCode || ''
    this.showProvince = process.env.VUE_APP_DITCHID === this.$route.query.ditchID
    this.isHuangShiProject = this.$route.query.uploadAppoinFiles === '1'
    this.bizId = this.$route.query.businessId
    if (this.orgForm.name && this.orgForm.codec && this.isHuangShiProject) {
      this.getHsHistoryFiles()
      this.isQueryAppointFiles = true
    }
  },
  methods: {
    // 下一步
    submit() {
      this.$refs.orgForm.validate(valid => {
        if (valid)
          if (this.isHuangShiProject) {
            this.createHSOrg()
          } else {
            this.submitToServer()
          }
      })

      this.trackForOrgCreated() // 指定企业/无指定企业行为埋点
    },
    async submitToServer() {
      // 政采云埋点
      if (this.showProvince) {
        this.$tsignData.track('zcy_cabuy_province_select', {
          Province_select: this.orgForm.province,
          select_time: new Date(),
          our_user_id: this.userInfo.ouid,
        })
      }

      try {
        this.loading = true
        await this.verifyOrgan()
        const { orgId, operateCode } = await this.createOrgan()
        this.orgId = orgId
        if (operateCode === '1') {
          const name = await this.getMemberAdmin(orgId)
          this.name = name
          this.isApply = true
          this.loading = false

          return
        }
        if (operateCode === '2') {
          this.isKefu = true
          this.loading = false

          return
        }
        if (operateCode === '3' || operateCode === '4') {
          await this.markZQB(orgId)
        }
        this.$emit('confirm', orgId)
        this.loading = false
        // this.close()
      } catch (e) {
        console.error('创建企业错误', e)
        e.code && this.$dialog.toast({ icon: 'error', message: e.message, style: 'z-index: 100002' })
        this.loading = false
      }
    },
    // 假如企业
    async handleLink() {
      const { data, message } = await this.$Http.api({
        url: `webserver/user/organizations/${this.orgId}/invites/applyJoin`,
        method: 'POST',
        body: {
          orgId: this.orgId,
        },
      })
      if (data.joinResult === 'SUCCESS') {
        this.$message.success(`申请成功! 已向管理员发送请求，管理员通过后您将自动加入${this.orgForm.name}`)

        return this.close()
      }

      if (data.joinResult === 'PRE') {
        return (window.location.href = data.redirectUrl)
      }

      this.$message.error(message || '加入失败')
    },
    // 创建企业
    async createOrgan() {
      const { data } = await this.$Http.api({
        url: 'webserver/v1/organizations/create',
        method: 'POST',
        params: {},
        headers: { event: 'acc_register' },
        body: {
          credentials: {
            globalIdentity: 'CRED_ORG_USCC',
            usccCode: this.orgForm.codec,
          },
          properties: {
            name: this.orgForm.name,
          },
          source: this.source,
        },
      })

      return data
    },
    // 招签宝创建企业打标志
    async markZQB(orgId) {
      await this.$Http.api({
        url: `webserver/v1/bid-sign/organization/${orgId}/mark`,
        method: 'PUT',
      })
    },
    // 获取管理员权限
    async getMemberAdmin(orgId) {
      const { data } = await this.$Http.api({
        url: `webserver/v1/organizations/${orgId}/admins`,
        method: 'GET',
        body: {
          offset: 0,
          page: 1,
        },
      })

      return data.result[0].memberName
    },

    // 是否绕过二要素
    isPassVerifyOrgan() {
      // 当企业类型为党政机关事业单位和其他时，跳过二要素校验
      if (this.orgForm.orgType === 3 || this.orgForm.orgType === 4) return true
      // if (this.$route.query.orgvalidsign && OtherCodePattern.test(this.orgForm.codec) && this.orgForm.codec.length === 18) return true
      if (this.orgForm.name && whiteList[this.orgForm.codec] === this.orgForm.name) return true
    },

    // 企业二要素校验
    async verifyOrgan() {
      if (this.isPassVerifyOrgan()) return true
      try {
        const { data } = await this.$Http.api({
          url: 'webserver/v2/identity/verify/organization/enterprise/base',
          method: 'POST',
          body: {
            name: this.orgForm.name,
            orgCode: this.orgForm.codec,
          },
        })

        return data
      } catch (e) {
        if (e.code === 30504001) e.message = '企业名称与证件号信息比对不通过'

        return Promise.reject(e)
      }
    },

    // 关闭弹框
    close() {
      this.orgForm.province = ''
      this.$emit('update:visible', false)
      this.isKefu = false
      this.isApply = false
    },

    /**
     * 无指定参和有指定参页面打开次数与比例
     */
    trackForOrgCreated() {
      try {
        this.$tsignData.track('esignSheild_landing_orgCreate', {
          source: 'esign-sheild-isolate', // 渠道名称
          orgName: this.$route.query.orgName || '',
          ouid: this.userInfo ? this.userInfo.ouid : '',
        })
      } catch (e) {
        console.log('trackForOrgCreated', e)
      }
    },

    async createHSOrg() {
      // this.loading = true
      try {
        await this.$Http.api({
          url: 'webserver/v1/mix/mobileShield/channels/batchAddAppointFiles',
          method: 'POST',
          body: {
            ...this.orgForm,
            orgName: this.orgForm.name,
            orgCode: this.orgForm.codec,
            appointFiles: this.orgForm.appointFiles,
            bizId: this.bizId,
          },
        })
        this.submitToServer()
      } catch (error) {
        this.$message({
          message: error.message,
          type: 'error',
        })
      } finally {
        // this.loading = false
      }
    },
    // 黄石项目查询历史文件上传情况
    async getHsHistoryFiles() {
      const param = {
        orgName: this.orgForm.name,
        orgCode: this.orgForm.codec,
      }
      try {
        const { data } = await this.$Http.api({
          url: 'webserver/v1/mix/mobileShield/channels/queryAppointFiles',
          method: 'POST',
          body: param,
        })
        if (data) {
          Object.keys(data).forEach(item => {
            this.orgForm[item] = data[item] || []
          })
        }
      } catch (error) {
        this.$message.error(error)
      }
    },

    getNewFileList(fileList, type) {
      this.orgForm[this.typeKeyObj[type]] = fileList
    },
    changeOrgName() {
      if (this.isHuangShiProject) {
        if (this.orgForm.codec && !this.isQueryAppointFiles) {
          this.isQueryAppointFiles = true
          this.getHsHistoryFiles()
        }
      }
    },
    changeOrgCode() {
      if (this.isHuangShiProject) {
        if (this.orgForm.name && !this.isQueryAppointFiles) {
          this.isQueryAppointFiles = true
          this.getHsHistoryFiles()
        }
      }
    },
    downloadFile() {
      window.open('https://trial-cdn.esign.cn/upload/d92d1e0c-7985-5365-9fb9-5d8d64ce8275!!9-7.zip')
      // const fileId = 'b322db36f6824eed8e2463925b42192b'
      // this.$Http
      //   .api('', '', {
      //     url: `webserver/v1/files/${fileId}`,
      //     method: 'GET',
      //     params: {},
      //     body: {
      //       accountId: 'sys_accountId',
      //     },
      //   })
      //   .then(res => {
      //     if (res.data && res.data.downloadUrl) {
      //       window.open(res.data.downloadUrl)
      //     } else {
      //       window.open('https://trial-cdn.esign.cn/upload/d547f84b-2da5-56c9-8136-a0bb7e914801!!8-10.zip')
      //     }
      //   })
      //   .catch(e => {
      //     console.log(e)
      //     window.open('https://trial-cdn.esign.cn/upload/d547f84b-2da5-56c9-8136-a0bb7e914801!!8-10.zip')
      //   })
    },
  },
}
</script>

<style lang="less" scoped>
.create-org {
  .create-org-body {
    padding: 16px 24px;
    position: relative;

    .create-org-warn {
      padding: 10px 0;
      padding-left: 40px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: rgba(240, 162, 37, 1);

      background: #fcecd3;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;

      &::before {
        content: '';
        position: absolute;
        width: 12px;
        height: 12px;
        top: 50%;
        transform: translateY(-50%);
        left: 17px;
        background: url('./ic_create_org_warn.svg') no-repeat;
        background-size: contain;
      }
    }
    .create-org-form {
      margin: 54px 39px 15px 25px;
      min-height: 96.8px;
      .create-org-form-item {
        margin-bottom: 28px;
      }
    }
    .create-org-item {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(230, 55, 64, 1);
      line-height: 17px;
    }
    .create-org__link {
      color: #0975e1;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  /deep/ .el-dialog {
    .el-dialog__footer {
      border-top: 1px solid #e4e4e4;
      padding: 14px 20px 15px;
    }
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    color: #999999;
  }
  @media (max-width: 750px) {
    .el-dialog__wrapper {
      z-index: 100001 !important;
      height: 100vh;
      background: #ffffff;
    }
    .create-org-body {
      .create-org-warn {
        font-size: 12px;
        line-height: 15px;
      }
      .create-org-form {
        margin-left: 0;
        min-height: 125px;
        margin: 70px 0 0;
        .create-org-form-item {
          margin-bottom: 32px;
          /deep/ .el-input__inner {
            height: 40px;
            font-size: 14px;
            border-radius: 0;
            border: 1px solid rgba(228, 228, 228, 1);
          }
        }
      }
    }
    .auth-dialog-footer {
      display: flex;
      justify-content: center;
      padding: 0px 5px;
      .back-btn {
        width: 110px;
        height: 40px;
        margin-right: 5px;
        border-radius: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .submit {
        margin: 0;
        width: 100%;
        height: 40px;
        border-radius: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    /deep/ .el-dialog {
      width: 100% !important;
      height: 100%;
      margin: 0 !important;
      .el-dialog__header {
        border: none;
        background: #f7f8fa;
        text-align: center;
        padding: 12px 20px 12px;
        .el-dialog__headerbtn {
          top: 12px;
        }
      }
      .el-dialog__body {
        padding: 0;
        max-height: calc(100% - 105px);
        overflow: scroll;
      }
      .el-dialog__footer {
        padding: 0 18px;
        border: none;
      }
      .auth-dialog-footer {
        padding: 8px 0;
        .back-btn {
          display: none;
        }
      }
    }
  }
}
</style>
<style lang="less">
.create-org {
  .el-dialog__body {
    padding: 0;
  }
}
@media (max-width: 750px) {
  .v-modal {
    display: none !important;
  }
}
.custome-upload {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
  .custome-upload-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
</style>
